module.exports = __webpack_public_path__ + "img/olarias-49cf3404.jpg";